import { useEffect, useRef, useState } from "react";
import CustomText from "../atomic/CustomText";
import ArrowUp from "../../assets/svg/ArrowUp";
import DropDownIcon from "../../assets/svg/DropdownIcon";
import SelectProps from "../../services/models/customSelectProps.model";
import { ErrorMessage } from "formik";
import { twMerge } from "tailwind-merge";

export type optionType = {
  label: string;
  value: string | number;
  address?: string;
  zipcode?: string;
  state?: string;
  disabled?: boolean;
};

function CustomSelect({
  options,
  selected,
  optionsVisible,
  setSelected,
  className,
  isForm,
  dropdownClassName,
  disabled,
}: Readonly<SelectProps>): JSX.Element {
  const [dropdownOpen, setDropDownOpen] = useState<boolean>(
    optionsVisible ?? false
  );
  const [formSelection, setFormSelection] = useState<optionType | null>(null);
  const dropDownRef = useRef<any>();

  useEffect(() => {
    const unsubscribe = window.addEventListener("mousedown", (event) => {
      if (dropDownRef?.current && !dropDownRef?.current?.contains(event.target))
        return setDropDownOpen(false);
    });

    return () => unsubscribe;
  }, []);

  useEffect(() => {
    if (options?.length > 0) {
      setFormSelection(
        options?.find(
          (option) => isForm?.values[(isForm as any)?.name] === option.value
        ) ?? null
      );
    }
  }, [options?.length]);

  if (isForm?.labelInfo) {
    return (
      <div
        className={`w-full my-2 mr-2 relative ${(isForm as any)?.parentContainerClass
          }`}
        ref={dropDownRef}
      >
        {!!isForm?.labelInfo?.label && (
          <CustomText
            text={isForm?.labelInfo?.label}
            className={`inputLabel mb-3 ${isForm?.labelInfo?.required
              ? "after:content-['*'] after:ml-1 after:text-requiredRed"
              : ""
              } `}
            fontWeight="font-semibold"
          />
        )}
        <button
          type="button"
          disabled={disabled}
          onClick={() => setDropDownOpen((prevState) => !prevState)}
          className={twMerge(
            `border border-[#dddfe3] bg-[#f9f9fa] hover:border-primary focus-within::border-primary ${!!(isForm as any)?.parentContainerClass ? "p-1.5" : "p-2"
            } rounded-full flex justify-between items-center w-full text-left ${dropdownOpen ? "border-primary" : ""
            } ${disabled ? "cursor-not-allowed opacity-60 hover:border-[#dddfe3]" : ""}`,
            className
          )}
        >
          <CustomText
            text={formSelection?.label ?? "Please select"}
            fontWeight="font-normal"
            className={`${!!formSelection?.label === false ? "!text-[#B1B8C3]" : ""
              }`}
          />
          {dropdownOpen ? <ArrowUp /> : <DropDownIcon />}
        </button>
        {dropdownOpen && !disabled && (
          <ul
            className={`${twMerge(
              `border rounded-md py-2 z-[9999] bg-white w-full shadow-sm mt-1 absolute max-h-32 overflow-auto`,
              dropdownClassName
            )}`}
          >
            {options?.map((option) => (
              <li key={option?.value} className="hover:bg-sideNavGray p-2">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setDropDownOpen((prevState) => !prevState);

                    if (isForm?.setFieldValue) {
                      setFormSelection(option);
                      isForm?.setFieldValue(isForm?.name ?? "", option?.value);
                      // isForm?.setFieldTouched(isForm.labelInfo.inputId, true)
                    } else {
                      setSelected?.(option);
                    }
                  }}
                  className="w-full"
                >
                  <CustomText
                    text={option?.label}
                    fontWeight="font-normal"
                    className="text-left"
                  />
                </button>
              </li>
            ))}
          </ul>
        )}
        <ErrorMessage name={isForm?.labelInfo?.inputId}>
          {(msg) => <h6 className="text-xs text-requiredRed my-1">{msg}</h6>}
        </ErrorMessage>
      </div>
    );
  }
  return (
    <div className="w-full my-2 mr-2 relative" ref={dropDownRef}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setDropDownOpen((prevState) => !prevState)}
        className={`bg-white border border-[#BFC7CE] hover:border-primary focus-within::border-primary p-2 rounded-full flex justify-between items-center w-full text-left ${dropdownOpen ? "border-primary" : ""
          } ${className} ${disabled ? "cursor-not-allowed opacity-60 !bg-gray-100 hover:border-[#BFC7CE]" : ""}`}
      >
        <CustomText
          text={selected?.label ?? "Please select"}
          fontWeight="font-normal"
        />
        {dropdownOpen ? <ArrowUp /> : <DropDownIcon />}
      </button>
      {dropdownOpen && !disabled && (
        <ul className="border rounded-md py-2 z-[9999] bg-white w-full shadow-sm mt-1 absolute max-h-32 overflow-auto">
          {options?.map((option) => (
            <li key={option?.value} className="hover:bg-sideNavGray p-2">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelected?.(option);
                  setDropDownOpen((prevState) => !prevState);
                }}
                className="w-full"
              >
                <CustomText
                  text={option?.label}
                  fontWeight="font-normal"
                  className="text-left"
                />
                {option?.address && (
                  <CustomText
                    text={[option.address, option.state, option.zipcode]
                      .filter(Boolean)
                      .join(", ")}
                    fontWeight="font-normal"
                    fontSize="text-xs"
                    className="text-gray-500 text-left mt-0.5"
                  />
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CustomSelect;
